import WorldBorder from "./world-border";

class InfiniteWorld extends WorldBorder {
    constructor() {
        super();
    }

    limitToBorder(position) {}
}

export default InfiniteWorld;
